import addMonths from 'date-fns/add_months';

export default function(date: Date, amount: number) {
  return addMonths(date, amount);
}
